<header class="flex justify-between h-auto max-w-lg md:max-w-7xl p-4 pt-0 pb-0">
  <div class="flex items-center">
    <a routerLink="/dashboard">
      <div class="logo mt-2 mb-1.5 md:mt-3 md:mb-2 md:w-48 w-8/12"></div>
    </a>
  </div>
  <div class="flex items-left menu-container">
    @if (showLocationMenu) {
      <button mat-button [matMenuTriggerFor]="locationMenu" class="flex items-left location-menu-button md:mt-4 mt-5 mb-3.5 md:mb-9"
        (menuOpened)="isDropdownOpen = true"
        (menuClosed)="isDropdownOpen = false">
        <div class="location-name">{{ currentLocation()?.name }}</div>
      <div class="chevron w-4 h-4" [class.open]="isDropdownOpen" [ngStyle]="{
    'mask-image': 'url(/assets/chevron-right.svg)',
    '-webkit-mask-image': 'url(/assets/chevron-right.svg)'
    }">&#9662;</div> <!-- Downward chevron -->
      </button>
    }
    <mat-menu #locationMenu="matMenu" class="location-submenu">
      @for (loc of locations(); track loc) {
        <button mat-menu-item (click)="selectLocation(loc)">
          {{ loc.name || loc.id }}
        </button>
      }
    </mat-menu>
    <button mat-icon-button (click)="toggleSidenav()" class="main-menu-button">
      <mat-icon class="text-4xl size-12 text-black">menu</mat-icon>
    </button>
  </div>
</header>
